import React, { useEffect, useState } from "react";
import "./PopupModal.css";

export default function PopupModal() {
  const [show, setShow] = useState(false);

  // Show popup every time page loads
  useEffect(() => {
    setShow(true);
  }, []);

  const closePopup = () => {
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="popup-overlay" onClick={closePopup}>
      <div
        className="popup-container"
        onClick={(e) => e.stopPropagation()}  // prevent close when clicking inside
      >
        <div>
            <button className="close-btn" onClick={closePopup}>
            X
          </button>
          <img src="./images/siva.png" alt="SPST " style={{ width: '60%' }} />
        
        </div>

        <div style={{background:'white',padding:'25px',borderRadius:'6pt',border:'6px solid orange'}}>
          
          <br />
          <h2 style={styles.title}>Website Under Revamp</h2>

        <p style={styles.text}>
          Our website is currently undergoing improvements to serve you better.
        </p>

        <p style={styles.text}>
          <strong>Online booking services are temporarily unavailable.</strong>
        </p>

        <p style={styles.subText}>
          We appreciate your patience and understanding during this period.
          Please visit again soon for a better experience.
        </p>

        <p style={styles.contact}>
          For urgent enquiries, kindly contact us directly.
        </p>
        </div>



      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
  popup: {
    background: "#fff",
    padding: "25px",
    borderRadius: "8px",
    textAlign: "center",
    maxWidth: "400px",
    width: "90%",
    boxShadow: "0 5px 20px rgba(0,0,0,0.2)",
  },
  title: {
    color: "#b22222",
    marginBottom: "10px",
  },
  text: {
    fontSize: "15px",
    color: "#333",
    lineHeight: "1.6",
  },
  subText: {
    fontSize: "14px",
    color: "#555",
    marginTop: "10px",
  },
  contact: {
    fontSize: "14px",
    marginTop: "10px",
    color: "#444",
  },
  button: {
    marginTop: "20px",
    padding: "8px 18px",
    backgroundColor: "#b22222",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
  },
};